/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_LogoInputs */

const en_enum_setting_group_logo = /** @type {(inputs: Enum_Setting_Group_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Logo`)
};

const de_enum_setting_group_logo = /** @type {(inputs: Enum_Setting_Group_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe Logo`)
};

/**
* | output |
* | --- |
* | "Group Logo" |
*
* @param {Enum_Setting_Group_LogoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_logo = /** @type {((inputs?: Enum_Setting_Group_LogoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_LogoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_logo(inputs)
	return de_enum_setting_group_logo(inputs)
});